/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Campus_TitleInputs */

const en_gd_campus_title = /** @type {(inputs: Gd_Campus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You graduate when your app is live`)
};

const id_gd_campus_title = /** @type {(inputs: Gd_Campus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syarat lulus = aplikasi terbit`)
};

/**
* | output |
* | --- |
* | "You graduate when your app is live" |
*
* @param {Gd_Campus_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_campus_title = /** @type {((inputs?: Gd_Campus_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Campus_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_campus_title(inputs)
	return en_gd_campus_title(inputs)
});